import React, { useEffect, useState } from "react";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { mitraMeta } from "../../data/DataMetatags";
import { mitraBreadcrumb, defBreadcrumb } from "../../data/DataBreadcrumb";
import "lazysizes";
import {
  item,
  itemManfaat,
  listPartnerDesktop,
  listPartnerMobile,
} from "../../data/Mitra/DataMitra";
import TestimonialSlider from "../../components/UserInterface/Slider/Testimonial/TesimonialSlider";
import HeroBanner from "../../components/IndexPage/HeroBanner";
import { CardContainer } from "../../components/UserInterface/CardContainer";
import Description from "../../components/UserInterface/Description";
import Button from "../../components/UserInterface/Button";
import UseWindowSize from "../../components/UseWindowSize";

const Mitra = (props) => {
  const { breadcrumb, title, description, path, mitraList } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={mitraBreadcrumb} />
      <HeroBanner codename="Home" />
      <Wrapper>
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Kembangkan Bisnis Anda Bersama Kami!"
          fontMobile="17px"
          marginMobile="16px 0 8px 0"
        />
        <Description
          alignMobile="left"
          font="Roboto"
          fontSize="20px"
          mobileWidth="360px"
          text="Butuh solusi pembiayaan dan pembayaran untuk penjualan Anda? Home Credit jawabannya!"
          fontMobile="14px"
          marginMobile="0"
        />
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Manfaat Untuk Mitra"
          fontMobile="17px"
          marginMobile="28px 0 8px 0"
        />
        {itemManfaat.map((obj, key) => (
          <div key={key} style={{ padding: "8px 0" }}>
            <CardContainer
              key={key}
              title={obj.title}
              subtitle={obj.subtitle}
              withButton={false}
            />
          </div>
        ))}
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Mitra-mitra Kami"
          fontMobile="17px"
          marginMobile="28px 0 8px 0"
        />
        <MitraList mitraList={mitraList} />
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Apa Kata Mereka?"
          fontMobile="17px"
          marginMobile="28px 0 8px 0"
        />
        <TestimonialSlider items={item} withSlide={false} />
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Yuk, Mulai Sekarang!"
          fontMobile="17px"
          marginMobile="28px 0 16px 0"
        />
        <Button
          widthMobile="100%"
          fontWeight="bold"
          text="Pendaftaran Mitra Baru"
          onClick={() => window.open("/mitra/onboarding", "_self")}
        />
        <Description
          alignMobile="left"
          font="Roboto"
          fontWeight="bold"
          fontSize="23px"
          mobileWidth="360px"
          text="Masih Ada Pertanyaan?"
          fontMobile="17px"
          marginMobile="28px 0 16px 0"
        />
        <Button
          widthMobile="100%"
          bgColor="var(--color-white)"
          fontColor="var(--color-red)"
          fontWeight="bold"
          text="Cari Tahu Jawabannya"
          onClick={() =>
            window.open("/pertanyaan-umum/pengajuan-kontrak", "_self")
          }
        />
      </Wrapper>
      <style jsx>{`
        .section {
          margin: 24px 0;
        }
      `}</style>
    </Layout>
  );
};

const Wrapper = ({ children }) => {
  return (
    <div className="container">
      <div className="wrapper">{children}</div>
      <style jsx>{`
        .container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 16px 16px 64px 16px;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          max-width: 940px;
          width: 100%;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

const MitraList = ({ mitraList }) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  const [partner, setPartner] = useState({ icon: "none", button: "" });

  useEffect(() => {
    setWinSize(width);
  }, [partner]);

  const onShowPartner = () => {
    setPartner({ icon: "block", button: "none" });
  };

  return (
    <div
      style={{
        marginBottom: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="mitra-wrapper">
        <div className="desktop">
          {mitraList.listPartnerDesktop.map((item, index) => {
            return (
              <img
                data-src={item.url}
                alt={item.description}
                key={`${item.name}${index}`}
                className={`mitra-icon lazyload row-${index}`}
              />
            );
          })}
        </div>
        <div className="mobile">
          {mitraList.listPartnerMobile.map((item, index) => {
            return (
              <img
                data-src={item.url}
                alt={item.description}
                key={`${item.name}${index}`}
                className={`mitra-icon lazyload row-${index}`}
              />
            );
          })}
        </div>
        <div className="show-partner">
          <Button
            widthMobile="100%"
            bgColor="var(--color-white)"
            fontColor="var(--color-red)"
            fontWeight="bold"
            text="Lihat Semua"
            onClick={onShowPartner}
          />
        </div>
      </div>

      <style jsx>{`
        .mitra-wrapper {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          max-width: ${winSize > 600 ? "940px" : "650px"};
        }
        .mitra-icon {
          height: auto;
          width: 100%;
        }
        .mobile {
          display: none;
        }
        .row-1 {
          display: ${partner.icon};
        }
        .show-partner {
          margin: 24px;
          display: ${partner.button};
        }
        @media only screen and (max-width: 910px) {
          .mitra-wrapper {
            justify-content: center;
          }
        }
        @media only screen and (max-width: 800px) {
          .desktop {
            display: none;
          }
          .mobile {
            display: contents;
          }
        }
      `}</style>
    </div>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = mitraMeta;
  const mitraList = await { listPartnerDesktop, listPartnerMobile };

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title,
      },
    },
  ];

  return { props: { breadcrumb, title, description, path, mitraList } };
};
export default Mitra;
